'use client';

import { useEffect } from 'react';
import { useEvent, useStore } from 'effector-react';
import { UiContextMenuTheme } from '@nx-frontend/shared/types';
import { UiContextMenu } from './context-menu';
import {
  $isShownContextMenu,
  $positionContextMenu,
  $theme,
  closeContextMenuEvent,
  setContextMenuThemeEvent,
  $contextMenuStore,
} from './context-menu-store';

export const ContextMenuLayout = ({ theme }: { theme?: UiContextMenuTheme | undefined }) => {
  const isShown = useStore($isShownContextMenu);
  const position = useStore($positionContextMenu);
  const store = useStore($contextMenuStore);
  const { themeClassesMenu, themeClassesItem, items, zIndex, additionalStyles, usePopperSubmenu } = store;
  const themeValue = useStore($theme);
  const closeContextMenu = useEvent(closeContextMenuEvent);
  const setContextMenuTheme = useEvent(setContextMenuThemeEvent);
  const handleOverlayClick = () => {
    closeContextMenu();
  };

  useEffect(() => {
    if (theme !== undefined) {
      setContextMenuTheme(theme);
    }
  }, [theme, setContextMenuTheme]);
  if (isShown) {
    return (
      <div>
        <div
          className="fixed inset-0 z-50 opacity-1"
          onClick={handleOverlayClick}
          style={zIndex ? { zIndex } : {}}
        ></div>
        <UiContextMenu
          menuData={items}
          x={position.x}
          y={position.y}
          zIndex={zIndex}
          themeClassesMenu={themeClassesMenu}
          themeClassesItem={themeClassesItem}
          subX={position.subX}
          subY={position.subY}
          closeContextMenu={closeContextMenu}
          theme={themeValue}
          additionalStyles={additionalStyles}
          usePopperSubmenu={usePopperSubmenu}
        />
      </div>
    );
  } else {
    return null;
  }
};
